import { SpinTimer } from './Timer'

export default SpinTimer
